/* =============================================================
   DeckWächter — "Jetzt neu" Ankündigungs-Banner (global)
   - sitzt ganz oben über der Seite
   - dormant: zeigt sich der Öffentlichkeit erst, wenn LIVE = true
   - Vorschau jederzeit über  ?dwneu=1  in der URL
   - wegklickbar (×), merkt sich das Schließen pro Besucher
   ============================================================= */
(function () {
  if (window.__dwNew) return; window.__dwNew = true;

  var LIVE = true;  /* <-- auf true setzen, sobald das Produkt aktiv ist */
  var PREVIEW = /[?&]dwneu=1/.test(location.search);
  if (!LIVE && !PREVIEW) return;

  var LINK = '/products/kartenhuellen-schwarz-66x91-mm-card-sleeves-tcg-sammelkarten';
  var KEY = 'dwNewBanner_blacksleeves';
  try { if (localStorage.getItem(KEY)) return; } catch (e) {}

  var css = document.createElement('style');
  css.textContent =
    "@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@600;700&display=swap');" +
    ".dw-nb{position:relative;z-index:9996;display:flex;align-items:center;justify-content:center;gap:12px;background:linear-gradient(90deg,#ff3b2f,#ff6a00);color:#170505;font-family:'Oswald',sans-serif;font-weight:700;letter-spacing:.4px;padding:9px 46px 9px 16px;font-size:14px;text-align:center;box-shadow:0 4px 18px rgba(255,80,30,.45);overflow:hidden;}" +
    ".dw-nb a.dw-nb-link{color:#170505;text-decoration:none;display:inline-flex;align-items:center;gap:10px;flex-wrap:wrap;justify-content:center;}" +
    ".dw-nb .dw-nb-tag{background:#170505;color:#ffb24a;border-radius:99px;padding:3px 10px;font-size:11px;letter-spacing:1.4px;text-transform:uppercase;}" +
    ".dw-nb .dw-nb-cta{background:#170505;color:#fff;border-radius:99px;padding:5px 14px;font-size:12.5px;white-space:nowrap;}" +
    ".dw-nb .dw-nb-shine{position:absolute;top:0;left:-40%;width:40%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,.5),transparent);animation:dwNbShine 3.4s ease-in-out infinite;pointer-events:none;}" +
    "@keyframes dwNbShine{0%{left:-40%}55%{left:120%}100%{left:120%}}" +
    ".dw-nb-x{position:absolute;right:8px;top:50%;transform:translateY(-50%);width:30px;height:30px;border-radius:50%;border:0;cursor:pointer;background:rgba(23,5,5,.18);color:#170505;font-size:17px;line-height:1;display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:transparent;transition:.15s;}" +
    ".dw-nb-x:active{transform:translateY(-50%) scale(.9);}" +
    "@media(max-width:600px){.dw-nb{font-size:12.5px;padding:9px 42px 9px 12px;gap:8px;}.dw-nb .dw-nb-tag{display:none;}.dw-nb-x{width:34px;height:34px;font-size:19px;}}";
  (document.head || document.documentElement).appendChild(css);

  var bar = document.createElement('div');
  bar.className = 'dw-nb';
  bar.innerHTML =
    '<span class="dw-nb-shine"></span>' +
    '<a class="dw-nb-link" href="' + LINK + '">' +
      '<span class="dw-nb-tag">Jetzt neu</span>' +
      '<span>🔥 Kartenhüllen Schwarz — 66 × 91 mm, glasklar &amp; matt-schwarz</span>' +
      '<span class="dw-nb-cta">Jetzt entdecken →</span>' +
    '</a>' +
    '<button class="dw-nb-x" aria-label="Schließen">×</button>';

  function mount() {
    if (!document.body) return setTimeout(mount, 50);
    document.body.insertBefore(bar, document.body.firstChild);
    bar.querySelector('.dw-nb-x').addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      bar.style.display = 'none';
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();
